function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#263238;}\n\t.st1{fill:#40C4FF;}\n\t.st2{fill:#FFD740;}\n\t.st3{fill:#FF5252;}\n\t.st4{fill:#4DB6AC;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#4FC3F7;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Credit_Card"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M44.5,51.5h-35c-1.654,0-3-1.346-3-3v-23c0-1.654,1.346-3,3-3h35c1.654,0,3,1.346,3,3v23 C47.5,50.154,46.154,51.5,44.5,51.5z M9.5,23.5c-1.103,0-2,0.897-2,2v23c0,1.103,0.897,2,2,2h35c1.103,0,2-0.897,2-2v-23 c0-1.103-0.897-2-2-2H9.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M54.5,13h-35c-1.381,0-2.5,1.119-2.5,2.5V21h18h9.5c2.481,0,4.5,2.019,4.5,4.5V41h5.5 c1.381,0,2.5-1.119,2.5-2.5v-23C57,14.119,55.881,13,54.5,13z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M54.5,41.5H49c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h5.5c1.103,0,2-0.897,2-2v-23 c0-1.103-0.897-2-2-2h-35c-1.103,0-2,0.897-2,2V21c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-5.5c0-1.654,1.346-3,3-3h35 c1.654,0,3,1.346,3,3v23C57.5,40.154,56.154,41.5,54.5,41.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 28,
  className: "st1",
  width: 40,
  height: 5
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M47,33.5H7c-0.276,0-0.5-0.224-0.5-0.5v-5c0-0.276,0.224-0.5,0.5-0.5h40c0.276,0,0.5,0.224,0.5,0.5v5 C47.5,33.276,47.276,33.5,47,33.5z M7.5,32.5h39v-4h-39V32.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M42,47.5h-7c-0.827,0-1.5-0.673-1.5-1.5v-3c0-0.827,0.673-1.5,1.5-1.5h7c0.827,0,1.5,0.673,1.5,1.5v3 C43.5,46.827,42.827,47.5,42,47.5z M35,42.5c-0.275,0-0.5,0.224-0.5,0.5v3c0,0.276,0.225,0.5,0.5,0.5h7c0.275,0,0.5-0.224,0.5-0.5 v-3c0-0.276-0.225-0.5-0.5-0.5H35z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22,43H12c-0.276,0-0.5-0.224-0.5-0.5S11.724,42,12,42h10c0.276,0,0.5,0.224,0.5,0.5S22.276,43,22,43z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22,47H12c-0.276,0-0.5-0.224-0.5-0.5S11.724,46,12,46h10c0.276,0,0.5,0.224,0.5,0.5S22.276,47,22,47z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.5,55.5h-1c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h1c0.276,0,0.5,0.224,0.5,0.5 S18.776,55.5,18.5,55.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M36.5,55.5h-16c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h16c0.276,0,0.5,0.224,0.5,0.5 S36.776,55.5,36.5,55.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M46.5,9.5h-1C45.224,9.5,45,9.276,45,9s0.224-0.5,0.5-0.5h1C46.776,8.5,47,8.724,47,9S46.776,9.5,46.5,9.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M43.5,9.5h-16C27.224,9.5,27,9.276,27,9s0.224-0.5,0.5-0.5h16C43.776,8.5,44,8.724,44,9S43.776,9.5,43.5,9.5z "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M9,13.5H5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h4c0.276,0,0.5,0.224,0.5,0.5S9.276,13.5,9,13.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M7,15.5L7,15.5c-0.276,0-0.5-0.224-0.5-0.5l0.001-4c0-0.276,0.224-0.5,0.5-0.5l0,0c0.276,0,0.5,0.224,0.5,0.5 L7.5,15C7.5,15.276,7.276,15.5,7,15.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.001,7.5h-4c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h4c0.276,0,0.5,0.224,0.5,0.5 S15.277,7.5,15.001,7.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.001,9.5c-0.276,0-0.5-0.224-0.5-0.5V5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v4 C13.501,9.276,13.277,9.5,13.001,9.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M54,21.5c-0.276,0-0.5-0.224-0.5-0.5v-4c0-0.276-0.225-0.5-0.5-0.5h-4c-0.276,0-0.5-0.224-0.5-0.5 s0.224-0.5,0.5-0.5h4c0.827,0,1.5,0.673,1.5,1.5v4C54.5,21.276,54.276,21.5,54,21.5z"
})));

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card.4e59593b.svg";
export { ForwardRef as ReactComponent };